export default {
    install(Vue) {
      Vue.prototype.$isDate = function (val) {
        return val instanceof Date && !isNaN(val.valueOf());
      };
    },
};